import React from 'react';
import styled from '@emotion/styled';
import { LineWave, Triangle } from 'react-loader-spinner';
const FullWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bg-1);
`;
export const PageLoading = () => {
  return /*#__PURE__*/React.createElement(FullWrapper, null, /*#__PURE__*/React.createElement(Triangle, {
    height: "50",
    width: "50",
    color: "#165dff",
    ariaLabel: "page-loading",
    visible: true
  }));
};
export const ContentLoading = () => {
  const wrapperClass = 'items-center flex justify-center';
  return /*#__PURE__*/React.createElement(LineWave, {
    height: "100",
    width: "100",
    color: "#165dff",
    ariaLabel: "line-wave",
    wrapperStyle: {},
    wrapperClass: wrapperClass,
    visible: true,
    firstLineColor: "",
    middleLineColor: "",
    lastLineColor: ""
  });
};